export default __webpack_public_path__ + "images/059fae3837c4c2e6cdc820892baa11cf.png";